module.exports = __webpack_public_path__ + "img/manual.848e5b44.svg";